function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.string.link.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import React, { useMemo, useState } from 'react';
import ReactTooltip from 'react-tooltip';
import { Checkbox, FormControlLabel, Box } from '@applyboard/ui-components';
import { useEventTracker } from '@applyboard/ui-utils';
import { getApplicationStatusMessage } from "../../../../util/common";
import SimpleButton from "../../../../components/core/button/SimpleButton";
import ApplicationStatus from "../ApplicationStatus";
import DropdownSelect from "../../../../components/core/input/DropdownSelect";
import Modal from "../../../../components/Modal";
import CancellationReasonModal from "./CancellationReasonModal";
import ReadyForVisaCheckbox from "./ReadyForVisaCheckbox";
import { _StatusActionsWrapper, _StatusButtonWrapper, _UndecideButtonWrapper, Link } from "./styles";
import { withValOnClickEnhancer } from "../../../../components/enhancers";
import useStatusInfo from "./useStatusInfo";
import { getLink, statusMapActionToLabel } from "./utils";
import useStatusHandlers from "./useStatusHandlers";
import ArrivalStatus from "./ArrivalStatus";
import useInitialProps from "../../../../hooks/useInitialProps";
import useDispatch from "../../../../hooks/useDispatch";
import { handleCreateNoteFromTemplateOnSuccess, handleOnProcessDeferralSuccess } from "../../ActionMenuWrapper";
import { useHistory } from 'react-router-dom';
var SimpleButtonWithVal = withValOnClickEnhancer(SimpleButton);
var getAdmissionDecisionDropdownOptions = function getAdmissionDecisionDropdownOptions(actions) {
  var actionsArr = ['accept', 'reject', 'waitlist', 'program_closed'];
  var options = [];
  actions.forEach(function (action) {
    if (actionsArr.includes(action.name)) {
      options.push({
        label: statusMapActionToLabel[action.name],
        value: action.name
      });
    }
  });
  return options;
};
var findAction = function findAction(actions, name) {
  return actions.find(function (action) {
    return action.name === name;
  });
};
var getAdmissionDecisionDropdownValue = function getAdmissionDecisionDropdownValue(status, actions) {
  var name = status.accepted && findAction(actions, 'accept').name || status.rejected && findAction(actions, 'reject').name || status.waitlisted && findAction(actions, 'waitlist').name || status.program_closed && findAction(actions, 'program_closed').name;
  return name || null;
};
var undecideButton = function undecideButton(actionsWithPermissions, onUndecideHandler, undecideTooltip, disableUndecide) {
  var action = actionsWithPermissions.find(function (act) {
    return act.name === 'undecide';
  });
  if (!action) {
    return null;
  }
  return /*#__PURE__*/React.createElement(_UndecideButtonWrapper, null, /*#__PURE__*/React.createElement(_StatusActionsWrapper, null, /*#__PURE__*/React.createElement(_StatusButtonWrapper, {
    key: "undecide"
  }, /*#__PURE__*/React.createElement(SimpleButtonWithVal, {
    secondary: true,
    val: action.name,
    onClick: onUndecideHandler,
    disabled: Boolean(action.disabled || disableUndecide),
    "data-tip": undecideTooltip,
    "data-for": "status-disabled-tooltip"
  }, "Undecide"))));
};
var Status = function Status(_ref) {
  var application = _ref.application,
    disableAcceptReject = _ref.disableAcceptReject,
    disableSubmitted = _ref.disableSubmitted,
    hasPermission = _ref.hasPermission,
    onActionClickNoSweetAlert = _ref.onActionClickNoSweetAlert,
    onReadyForVisa = _ref.onReadyForVisa,
    onReadyToSubmit = _ref.onReadyToSubmit,
    onSubmittedToSchool = _ref.onSubmittedToSchool,
    info = _ref.info,
    onActionClick = _ref.onActionClick,
    reloadAggregatedData = _ref.reloadAggregatedData,
    ProcessDeferralModal = _ref.ProcessDeferralModal,
    isMarkdownRendererEnabled = _ref.isMarkdownRendererEnabled;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    cancellationReasonModalVisible = _useState2[0],
    setCancellationReasonModalVisible = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    cancellationAction = _useState4[0],
    setCancellationAction = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    cancellationActionLink = _useState6[0],
    setCancellationActionLink = _useState6[1];
  var _useState7 = useState(undefined),
    _useState8 = _slicedToArray(_useState7, 2),
    modalReason = _useState8[0],
    setModalReason = _useState8[1];
  var _useState9 = useState(undefined),
    _useState10 = _slicedToArray(_useState9, 2),
    modalContext = _useState10[0],
    setModalContext = _useState10[1];
  var _useEventTracker = useEventTracker(),
    trackEvent = _useEventTracker.trackEvent;
  var _useInitialProps = useInitialProps(),
    arrivalStatusEnabled = _useInitialProps.arrivalStatusEnabled,
    role = _useInitialProps.role,
    applicationId = _useInitialProps.id,
    initialApplicationProps = _useInitialProps.application;
  var applicationStatus = getApplicationStatusMessage(application);
  var setCancellationDefaultState = function setCancellationDefaultState(reason, context) {
    setModalReason(reason);
    setModalContext(context);
  };
  var clearCancellationDefaultState = function clearCancellationDefaultState() {
    setModalReason(undefined);
    setModalContext(undefined);
  };
  var _useMemo = useMemo(function () {
      var _info$status, _info$status2;
      var newRenderStatusAction = (info === null || info === void 0 ? void 0 : (_info$status = info.status) === null || _info$status === void 0 ? void 0 : _info$status.actions) && info.status.actions.length > 0;
      var actions = info === null || info === void 0 ? void 0 : (_info$status2 = info.status) === null || _info$status2 === void 0 ? void 0 : _info$status2.actions;

      // reformat status action buttons with permissions
      var newActionsWithPermissions = actions && actions.length > 0 && actions.map(function (action) {
        return {
          link: action.link,
          name: action.name,
          disabled: !hasPermission("status_update_".concat(action.name))
        };
      });
      var newCancellationLinksPresent = getLink(info, 'cancel') || getLink(info, 'uncancel');
      return {
        renderStatusAction: newRenderStatusAction,
        actionsWithPermissions: newActionsWithPermissions,
        cancellationLinksPresent: newCancellationLinksPresent
      };
    }, [info, hasPermission]),
    renderStatusAction = _useMemo.renderStatusAction,
    actionsWithPermissions = _useMemo.actionsWithPermissions,
    cancellationLinksPresent = _useMemo.cancellationLinksPresent;
  var _useStatusInfo = useStatusInfo(application, {
      hasPermission: hasPermission
    }),
    admissionDecisionTooltip = _useStatusInfo.admissionDecisionTooltip,
    disableAdmissionDecision = _useStatusInfo.disableAdmissionDecision,
    disableEnrollmentConfirmed = _useStatusInfo.disableEnrollmentConfirmed,
    disableReadyToEnroll = _useStatusInfo.disableReadyToEnroll,
    disableUndecide = _useStatusInfo.disableUndecide,
    enrollmentConfirmedToolTip = _useStatusInfo.enrollmentConfirmedToolTip,
    readyToEnrollToolTip = _useStatusInfo.readyToEnrollToolTip,
    undecideTooltip = _useStatusInfo.undecideTooltip,
    disableSubmitToSchool = _useStatusInfo.disableSubmitToSchool,
    submitToSchoolTooltip = _useStatusInfo.submitToSchoolTooltip,
    disableReadyForVisa = _useStatusInfo.disableReadyForVisa,
    readyForVisaToolTip = _useStatusInfo.readyForVisaToolTip,
    disableRefundInProgress = _useStatusInfo.disableRefundInProgress,
    refundInProgressToolTip = _useStatusInfo.refundInProgressToolTip,
    disableDeferralInProgress = _useStatusInfo.disableDeferralInProgress,
    deferralInProgressToolTip = _useStatusInfo.deferralInProgressToolTip,
    readyToSubmitTooltip = _useStatusInfo.readyToSubmitTooltip,
    disableReadyToSubmitCheckbox = _useStatusInfo.disableReadyToSubmitCheckbox,
    disableWithdraw = _useStatusInfo.disableWithdraw,
    withdrawToolTip = _useStatusInfo.withdrawToolTip,
    isEditReasonVisible = _useStatusInfo.isEditReasonVisible;
  var _useStatusHandlers = useStatusHandlers({
      clearCancellationDefaultState: clearCancellationDefaultState,
      info: info,
      onActionClick: onActionClick,
      setCancellationAction: setCancellationAction,
      setCancellationActionLink: setCancellationActionLink,
      setCancellationDefaultState: setCancellationDefaultState,
      setCancellationReasonModalVisible: setCancellationReasonModalVisible
    }),
    onAdmissionDropdownChange = _useStatusHandlers.onAdmissionDropdownChange,
    onCancelDeferralInProgressHandler = _useStatusHandlers.onCancelDeferralInProgressHandler,
    onCancelEnrollmentConfirmedHandler = _useStatusHandlers.onCancelEnrollmentConfirmedHandler,
    onCancelHandler = _useStatusHandlers.onCancelHandler,
    onCancelReadyToEnrollHandler = _useStatusHandlers.onCancelReadyToEnrollHandler,
    onCancelRefundInProgressHandler = _useStatusHandlers.onCancelRefundInProgressHandler,
    onCloseCancellationReasonModal = _useStatusHandlers.onCloseCancellationReasonModal,
    onEditReasonHandler = _useStatusHandlers.onEditReasonHandler,
    onEnableDeferralInProgressHandler = _useStatusHandlers.onEnableDeferralInProgressHandler,
    onEnableEnrollmentConfirmedHandler = _useStatusHandlers.onEnableEnrollmentConfirmedHandler,
    onEnableReadyToEnrollHandler = _useStatusHandlers.onEnableReadyToEnrollHandler,
    onEnableRefundInProgressHandler = _useStatusHandlers.onEnableRefundInProgressHandler,
    onReactivateHandler = _useStatusHandlers.onReactivateHandler,
    onUncancelHandler = _useStatusHandlers.onUncancelHandler,
    onUndecideHandler = _useStatusHandlers.onUndecideHandler,
    onWithdrawHandler = _useStatusHandlers.onWithdrawHandler;
  var _getStatusCheckboxVal = getStatusCheckboxValues({
      application: application,
      actionsWithPermissions: actionsWithPermissions
    }),
    admissionDecisionValue = _getStatusCheckboxVal.admissionDecisionValue,
    cancelValue = _getStatusCheckboxVal.cancelValue,
    deferralInProgressValue = _getStatusCheckboxVal.deferralInProgressValue,
    enrollmentConfirmedValue = _getStatusCheckboxVal.enrollmentConfirmedValue,
    readyToEnrollValue = _getStatusCheckboxVal.readyToEnrollValue,
    readyToSubmitValue = _getStatusCheckboxVal.readyToSubmitValue,
    refundInProgressValue = _getStatusCheckboxVal.refundInProgressValue,
    submittedToSchoolValue = _getStatusCheckboxVal.submittedToSchoolValue,
    withdrawValue = _getStatusCheckboxVal.withdrawValue;
  var submittedToSchoolDisabled = !hasPermission('status_update_submitted') || disableSubmitted || disableSubmitToSchool;
  var admissionDecisionDisabled = !!disableAcceptReject || disableAdmissionDecision || actionsWithPermissions && actionsWithPermissions.some(function (action) {
    return action.name === 'undecide';
  });
  var admissionDecisionOptions = useMemo(function () {
    return actionsWithPermissions ? getAdmissionDecisionDropdownOptions(actionsWithPermissions) : [];
  }, [actionsWithPermissions]);
  var deferralInProgressOnChange = deferralInProgressValue ? onCancelDeferralInProgressHandler : onEnableDeferralInProgressHandler;
  var refundInProgressOnChange = refundInProgressValue ? onCancelRefundInProgressHandler : onEnableRefundInProgressHandler;
  var cancelOnChange = cancelValue ? onUncancelHandler : onCancelHandler;
  var withdrawOnChange = withdrawValue ? onReactivateHandler : onWithdrawHandler;
  var readyToEnrollOnChange = readyToEnrollValue ? onCancelReadyToEnrollHandler : onEnableReadyToEnrollHandler;
  var enrollmentConfirmedOnChange = enrollmentConfirmedValue ? onCancelEnrollmentConfirmedHandler : onEnableEnrollmentConfirmedHandler;
  var showSubmissionStatus = hasPermission('view_submission_status');
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isUpdateStatusModalOpen = _useState12[0],
    setIsUpdateStatusModalOpen = _useState12[1];
  var dispatch = useDispatch();
  var history = useHistory();
  return /*#__PURE__*/React.createElement("div", null, showSubmissionStatus && /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start"
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      checked: readyToSubmitValue,
      onChange: function onChange() {
        onReadyToSubmit().then(function () {
          reloadAggregatedData();
        });
        trackEvent({
          event: "Single Application - Status - ".concat(!application.status.ready_to_submit ? 'Checked' : 'Unchecked', " Ready To Submit Checkbox"),
          data: {
            userRole: role,
            applicationStatus: applicationStatus
          }
        });
      },
      name: "ready_to_submit",
      color: "primary",
      disabled: disableReadyToSubmitCheckbox
    }),
    "data-tip": readyToSubmitTooltip,
    "data-for": "status-disabled-tooltip",
    label: "Ready to Submit",
    labelPlacement: "start",
    m: 0
  }), /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      checked: submittedToSchoolValue,
      onChange: function onChange() {
        onSubmittedToSchool().then(function () {
          reloadAggregatedData();
        });
        trackEvent({
          event: "Single Application - Status - ".concat(!application.status.submitted ? 'Checked' : 'Unchecked', " Submitted To School Checkbox"),
          data: {
            userRole: role,
            applicationStatus: applicationStatus
          }
        });
      },
      name: "submitted_to_school",
      color: "primary",
      disabled: submittedToSchoolDisabled
    }),
    "data-tip": submitToSchoolTooltip,
    "data-for": "status-disabled-tooltip",
    label: "Submitted to School",
    labelPlacement: "start",
    m: 0
  }), renderStatusAction && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    "data-tip": admissionDecisionTooltip
  }, /*#__PURE__*/React.createElement("div", null, "Admission Decision"), /*#__PURE__*/React.createElement(DropdownSelect, {
    disabled: admissionDecisionDisabled,
    name: "admission_decision",
    placeholder: "Select...",
    type: "select",
    inputValue: admissionDecisionValue,
    onChange: onAdmissionDropdownChange,
    options: admissionDecisionOptions
  })), actionsWithPermissions ? undecideButton(actionsWithPermissions, onUndecideHandler, undecideTooltip, disableUndecide) : null), /*#__PURE__*/React.createElement(ReadyForVisaCheckbox, {
    application: application,
    disabled: disableReadyForVisa,
    onChange: onReadyForVisa,
    tooltip: readyForVisaToolTip,
    reloadAggregatedData: reloadAggregatedData
  }), arrivalStatusEnabled && /*#__PURE__*/React.createElement(ArrivalStatus, {
    disableEnrollmentConfirmed: disableEnrollmentConfirmed,
    disableReadyToEnroll: disableReadyToEnroll,
    enrollmentConfirmedOnChange: enrollmentConfirmedOnChange,
    enrollmentConfirmedToolTip: enrollmentConfirmedToolTip,
    enrollmentConfirmedValue: enrollmentConfirmedValue,
    readyToEnrollOnChange: readyToEnrollOnChange,
    readyToEnrollToolTip: readyToEnrollToolTip,
    readyToEnrollValue: readyToEnrollValue
  }), /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start"
  }, renderStatusAction ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      checked: deferralInProgressValue,
      onChange: function onChange() {
        // TODO: when integrating this with the BE check to see if deferralInProgressOnChange is still needed
        if (deferralInProgressValue && ProcessDeferralModal) {
          setIsUpdateStatusModalOpen(!isUpdateStatusModalOpen);
        } else {
          deferralInProgressOnChange();
        }
      },
      name: "deferral_in_progress",
      color: "primary",
      disabled: disableDeferralInProgress
    }),
    "data-tip": deferralInProgressToolTip,
    "data-for": "status-disabled-tooltip",
    label: "Deferral in Progress",
    labelPlacement: "start",
    m: 0
  }), /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      checked: refundInProgressValue,
      onChange: refundInProgressOnChange,
      onClick: function onClick() {
        trackEvent({
          event: 'Single Application - Status - Clicked Refund in Progress'
        });
      },
      name: "deferral_in_progress",
      color: "primary",
      disabled: disableRefundInProgress
    }),
    "data-tip": refundInProgressToolTip,
    "data-for": "status-disabled-tooltip",
    label: "Refund in Progress",
    labelPlacement: "start",
    m: 0
  }), /*#__PURE__*/React.createElement(React.Fragment, null, !submittedToSchoolValue && cancellationLinksPresent ? /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      checked: cancelValue,
      onChange: function onChange() {
        trackEvent({
          event: 'Single Application - Status - Clicked Cancel Application',
          data: {
            applicationStatus: getApplicationStatusMessage(application),
            applicationStage: initialApplicationProps === null || initialApplicationProps === void 0 ? void 0 : initialApplicationProps.current_stage
          }
        });
        cancelOnChange();
      },
      name: "cancel",
      color: "primary"
    }),
    label: "Cancel",
    labelPlacement: "start",
    m: 0
  }) : submittedToSchoolValue && !cancelValue && !cancellationLinksPresent && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      checked: withdrawValue,
      onChange: withdrawOnChange,
      disabled: disableWithdraw,
      name: "withdrraw",
      color: "primary"
    }),
    "data-tip": withdrawToolTip,
    "data-for": "status-disabled-tooltip",
    label: "Withdraw",
    labelPlacement: "start",
    m: 0
  }))), isEditReasonVisible && /*#__PURE__*/React.createElement(Link, {
    onClick: onEditReasonHandler
  }, "Edit Reason")) : null)), /*#__PURE__*/React.createElement(ApplicationStatus, {
    application: application
  }), cancellationReasonModalVisible && /*#__PURE__*/React.createElement(Modal, {
    onClickOff: onCloseCancellationReasonModal,
    "aria-labelledby": "cancellationModalTitle"
  }, /*#__PURE__*/React.createElement(CancellationReasonModal, {
    applicationId: applicationId,
    applicantId: initialApplicationProps.user_id,
    applicationStatus: applicationStatus,
    cancellationAction: cancellationAction,
    cancellationActionLink: cancellationActionLink,
    context: modalContext,
    onClose: onCloseCancellationReasonModal,
    performSubmitAction: onActionClickNoSweetAlert,
    reason: modalReason,
    userRole: role,
    reloadAggregatedData: reloadAggregatedData
  })), /*#__PURE__*/React.createElement(ReactTooltip, {
    id: "status-disabled-tooltip",
    html: true
  }), ProcessDeferralModal && /*#__PURE__*/React.createElement(ProcessDeferralModal, {
    isOpen: isUpdateStatusModalOpen,
    onOpenChange: setIsUpdateStatusModalOpen,
    onSuccess: function onSuccess(intakeInformation) {
      return dispatch(handleOnProcessDeferralSuccess(applicationId, intakeInformation));
    },
    onDismissSuccess: function onDismissSuccess() {
      return dispatch(handleCreateNoteFromTemplateOnSuccess({
        applicationId: applicationId,
        history: history,
        isMarkdownRendererEnabled: isMarkdownRendererEnabled
      }));
    }
  }));
};
function getStatusCheckboxValues(_ref2) {
  var _application$status, _application$status2, _application$status3, _application$status4, _application$status5, _application$status6, _application$status7, _application$status8;
  var actionsWithPermissions = _ref2.actionsWithPermissions,
    application = _ref2.application;
  return {
    admissionDecisionValue: application !== null && application !== void 0 && application.status && actionsWithPermissions ? getAdmissionDecisionDropdownValue(application.status, actionsWithPermissions) : null,
    cancelValue: !!(application !== null && application !== void 0 && (_application$status = application.status) !== null && _application$status !== void 0 && _application$status.canceled),
    deferralInProgressValue: !!(application !== null && application !== void 0 && (_application$status2 = application.status) !== null && _application$status2 !== void 0 && _application$status2.deferral_in_progress),
    enrollmentConfirmedValue: !!(application !== null && application !== void 0 && (_application$status3 = application.status) !== null && _application$status3 !== void 0 && _application$status3.enrollment_confirmed),
    readyToEnrollValue: !!(application !== null && application !== void 0 && (_application$status4 = application.status) !== null && _application$status4 !== void 0 && _application$status4.ready_to_enroll),
    readyToSubmitValue: !!(application !== null && application !== void 0 && (_application$status5 = application.status) !== null && _application$status5 !== void 0 && _application$status5.ready_to_submit),
    refundInProgressValue: !!(application !== null && application !== void 0 && (_application$status6 = application.status) !== null && _application$status6 !== void 0 && _application$status6.refund_in_progress),
    submittedToSchoolValue: !!(application !== null && application !== void 0 && (_application$status7 = application.status) !== null && _application$status7 !== void 0 && _application$status7.submitted),
    withdrawValue: !!(application !== null && application !== void 0 && (_application$status8 = application.status) !== null && _application$status8 !== void 0 && _application$status8.withdrawn)
  };
}
export default Status;